// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"a33c035e","583":"5e3203f2","592":"1ef87149","975":"c488254c","983":"85068759"}[chunkId] + ".chunk.js";
};